import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { registerCmsTranslations } from 'i18n/register-translations';
// import '../../cms/cms-build-expiry.css';
import { getBuildExpiresAtMs, getBuildTimeMs, getRemainingMs, isBuildExpired, isBuildExpiryEnabled, } from './build-expiry';
let translationsRegistered = false;
const ensureTranslations = () => {
    if (!translationsRegistered) {
        registerCmsTranslations();
        translationsRegistered = true;
    }
};
const BuildExpiryLockScreen = () => {
    const buildTime = getBuildTimeMs();
    const expiresAt = getBuildExpiresAtMs();
    return (_jsx("div", { className: "cms-build-expiry cms-build-expiry--locked", role: "alert", children: _jsx("div", { className: "cms-build-expiry__panel" }) }));
};
export const BuildExpiryGate = ({ children }) => {
    const [remainingMs, setRemainingMs] = useState(() => getRemainingMs());
    const enabled = isBuildExpiryEnabled();
    useEffect(() => {
        if (enabled) {
            ensureTranslations();
        }
    }, [enabled]);
    useEffect(() => {
        if (!enabled) {
            return undefined;
        }
        const tick = () => setRemainingMs(getRemainingMs());
        tick();
        const timerId = window.setInterval(tick, 1000);
        return () => window.clearInterval(timerId);
    }, [enabled]);
    if (!enabled) {
        return _jsx(_Fragment, { children: children });
    }
    if (isBuildExpired() || remainingMs <= 0) {
        return _jsx(BuildExpiryLockScreen, {});
    }
    return _jsx(_Fragment, { children: children });
};
export default BuildExpiryGate;
